document.addEventListener('DOMContentLoaded', () => {
  const qtyInputs = document.querySelectorAll('.quantity__input');

  /**
   * Returns a unique key for the product associated with a quantity input.
   * First, it tries to use `data-product-id` from the closest <quantity-input> parent.
   * If not found, it falls back to `data-quantity-variant-id`.
   *
   * @param {HTMLInputElement} input - The quantity input element.
   * @returns {string|null} The product key or null if not found.
   */
  function getProductKey(input) {
    const wrapper = input.closest('quantity-input');
    if (wrapper && wrapper.dataset.productId) {
      return wrapper.dataset.productId;
    }
    if (input.dataset.quantityVariantId) {
      return input.dataset.quantityVariantId;
    }
    return null;
  }

  /**
   * Synchronizes the value of the quantity input across all inputs
   * for the same product (matched by productId or variantId).
   *
   * @param {HTMLInputElement} input - The quantity input that changed.
   * @returns {void}
   */
  function syncQuantity(input) {
    const key = getProductKey(input);
    if (!key) return;

    const newValue = input.value;

    qtyInputs.forEach((otherInput) => {
      if (otherInput !== input && getProductKey(otherInput) === key) {
        otherInput.value = newValue;
        otherInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  qtyInputs.forEach((input) => {
    input.addEventListener('input', () => syncQuantity(input));
  });

  const qtyButtons = document.querySelectorAll('.quantity__button');
  qtyButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const input = btn.closest('quantity-input').querySelector('.quantity__input');
      setTimeout(() => syncQuantity(input), 10);
    });
  });
});
